import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5342b304"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "gift-anim-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "lottie-animation" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { style: {"color":"#fff","line-height":"1.3"} }
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "OK", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, $setup.showGiftBoxAnimation]
    ]),
    ($setup.isNativeApp() && $setup.settings.showGetGiftToolbar == 1 && $setup.user.gotWelcomeGift == null)
      ? (_openBlock(), _createBlock(_component_ion_toolbar, {
          key: 0,
          color: "success"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, {
              slot: "start",
              size: "large",
              icon: $setup.gift,
              style: {"padding-left":"10px"}
            }, null, 8, ["icon"]),
            _createVNode(_component_ion_title, { style: {"padding-right":"0","padding-left":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_4, [
                      _createElementVNode("b", null, _toDisplayString($setup.getLocalizedStr($setup.settings, ($setup.userLoggedIn ? 'getGiftText' : 'guestGetGiftText'), ($setup.userLoggedIn ? 'getGiftTextEn' : 'guestGetGiftTextEn'))), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              color: "light",
              slot: "end",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.getGift())),
              style: {"font-size":"16px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.getLocalizedStr($setup.settings, ($setup.userLoggedIn ? 'getGiftBtnText' : 'guestGetGiftBtnText'), ($setup.userLoggedIn ? 'getGiftBtnTextEn' : 'guestGetGiftBtnTextEn'))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_modal, {
      id: "gift-modal",
      class: "ion-text-center",
      "is-open": $setup.isGiftModalOpened,
      "show-backdrop": false,
      backdropDismiss: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          ($setup.resultGift.photoLink)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                style: {"width":"300px"},
                src: $setup.addResizeUrlParams($setup.resultGift.photoLink, 500)
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createBlock(_component_ion_card_header, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($setup.t('congratsYouGot')) + " " + _toDisplayString($setup.resultGift.name) + "！", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _createVNode(_component_ion_button, {
          color: "success",
          size: "large",
          shape: "round",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onCompleteGetGift())),
          style: {"--border-radius":"0","margin":"-3px"}
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}